import { Avatar, Button, StatusComponent } from '@efexteam/components';
import { RoleIds } from '@efexteam/permission-manager';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OutletLayout from '../../layout/OutletLayout';
import useViewControl from './hooks/useViewControl';
import MyProfile from './MyProfile';
import MyTeam from './myTeam/MyTeam';
import ProfileStyles from './Profile.style';

const Profile = () => {
  const { t } = useTranslation();

  const { activeView, fullName, roleId, setActiveView } = useViewControl();

  return (
    <OutletLayout>
      <Box className={ProfileStyles.headerSection}>
        <Avatar username={fullName} size="lg" />
        <Typography variant="h4">{fullName}</Typography>
        <StatusComponent
          displayVariant="chip"
          status="generic"
          size="small"
          className={ProfileStyles.userRoleChip}
          label={roleId ? t(`member${RoleIds[roleId]?.toUpperCase()}`) : ''}
        />
      </Box>
      <div className="flex justify-start items-center gap-5">
        <Button
          appearance="primary"
          onClick={() => setActiveView('profile')}
          className={ProfileStyles.sectionButtons(activeView === 'profile')}
          variant="text"
        >
          {t('myAccount') || ''}
        </Button>
        <Button
          appearance="primary"
          onClick={() => setActiveView('team')}
          className={ProfileStyles.sectionButtons(activeView === 'team')}
          variant="text"
        >
          {t('myTeam') || ''}
        </Button>
      </div>
      {activeView === 'profile' && <MyProfile />}
      {activeView === 'team' && <MyTeam />}
    </OutletLayout>
  );
};

export default Profile;
